import React, {useState, useEffect, useCallback, useContext} from 'react'
import {useHttp} from "../hooks/http.hook"
import {
    getAuthHeader,
    getItems,
    getLocalStorageItem,
    getPathAndQueryParams,
    objectLang,
    setCookieOfFolder,
    setErrorWindow,
    setLocalStorageItem
} from "../functions"
import config from '../config'
import {AuthContext} from '../context/AuthContext'
import {LoaderClass} from "../elements/LoaderClass"
import {ModalWin} from "../elements/ModalWin"
import {LinksClass} from "../components/LinksClass"
import {useNavigate, useParams} from "react-router-dom"
import {PathLineClass} from "../elements/PathLineClass"

export const GooglePhotoPage = () => {
    setLocalStorageItem('page', 'GooglePhotoPage')
    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [documents, setDocuments] = useState(null)
    const [items, setItems] = useState([])
    const [dataModal, setDataModal] = useState({})
    const [pageToken, setPageToken] = useState(null)
    const [folders, setFolders] = useState([])
    const [links, setLinks] = useState([])
    const [countItems, setCountItems] = useState(0)
    const [itemId, setItemId] = useState(null)
    const [isLoadingThumb, setIsLoadingThumb] = useState(false)
    const navigate = useNavigate()
    const {id: folderId} = useParams()

    const host =
        window.location.host === 'localhost:3000'
            ? config.localHost
            : config.onrender

    const MAX_ITEMS = 1000
    const sort = getLocalStorageItem(`sort-G-${folderId}`) || 'type'
    const order = getLocalStorageItem(`order-G-${folderId}`) || 'asc'

    // --- Загрузка контента Google Drive ---
    const loadContent = useCallback(
        async (pageToken = null) => {
            const lang = objectLang().language
            const l = lang.lang
            try {
                const data = await request(
                    `${host}/api/google-photos/photos/all?redirectURI=${window.location.origin}&pageToken=null&MAX_ITEMS=${MAX_ITEMS}&sort=name&order=asc`,
                    'GET',
                    null,
                    {
                        Authorization: getAuthHeader(auth),
                        'Content-Type': 'application/json',
                    }
                )

                if (data.status > 201 && data.code !== 6042) {
                    setAllowed(false)
                    setDataModal(setErrorWindow(
                        lang.modal.errors.title,
                        data.code,
                        lang.messages.code_541,
                        lang.modal.buttons.btnOK,
                        `replaceTo /${l}/`,
                        lang.modal.buttons.btnCancel,
                        `replaceTo ${getPathAndQueryParams()}`
                    ))
                    return
                }
                if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
                if (!pageToken) {
                    setDocuments(data.documents)
                    setItems([])
                    setPageToken(data.nextPageToken || null)
                    setCountItems(data.documents.folders.length + data.documents.links.length + data.documents.notes.length)
                    setLocalStorageItem(`sort-G-${data.documents.parent}`, data.documents.sort)
                    setLocalStorageItem(`order-G-${data.documents.parent}`, data.documents.order)
                    setCookieOfFolder(data.documents)
                } else {
                    if (data.documents) {
                        setFolders(data.documents.folders)
                        setLinks(data.documents.links)
                        setPageToken(data.nextPageToken || null)
                        setItemId(data.documents.parent)
                        setCountItems(countItems + data.documents.folders.length + data.documents.links.length + data.documents.notes.length)
                        setLocalStorageItem(`sort-G-${data.documents.parent}`, data.documents.sort)
                        setLocalStorageItem(`order-G-${data.documents.parent}`, data.documents.order)
                        setCookieOfFolder(data.documents)
                        setLocalStorageItem(`pageToken-${data.documents.parent}`, data.nextPageToken || null)
                    } else {
                        setPageToken(null)
                    }
                }

            } catch (err) {
                console.error('Ошибка загрузки контента:', err)
            }
        },
        [auth, request, host, folderId, order, sort]
    )

    // --- Основная загрузка при монтировании ---
    useEffect(() => {
        if (itemId === folderId) {
            loadContent(pageToken).then()
        } else {
            setFolders([])
            setLinks([])
            setPageToken(null)
            const docsLocal = getLocalStorageItem(folderId)
            if (docsLocal && docsLocal.sort === sort && docsLocal.order === order) {
                setLocalStorageItem('currentParent', docsLocal.parent)
                setTimeout(() => {
                    setDocuments(docsLocal)
                    setItems([])
                    setCountItems(docsLocal.folders.length + docsLocal.links.length + docsLocal.notes.length)
                    setLocalStorageItem(`sort-${docsLocal.parent}`, docsLocal.sort)
                    setLocalStorageItem(`order-${docsLocal.parent}`, docsLocal.order)
                }, 100)
                if (document.getElementById('filterInput')) {
                    document.getElementById('filterInput').value = ''
                    const arr = Array.from(document.getElementById('items').children)
                    for (const i in arr) {
                        arr[i].classList.remove("d-none")
                    }
                }
            } else {
                loadContent().then(() => {
                })
            }
        }
    }, [loadContent, folderId, itemId, setIsLoadingThumb, pageToken, sort, order])

    // --- Отрисовка ---
    if (!allowed) return <ModalWin data={dataModal}/>

    if (documents) {
        documents.googleDrive = true // Мы открываем гугл драйв
        const f = documents.folders
        const l = documents.links
        for (const i in folders) {
            f.push(folders[i])
        }
        for (const i in links) {
            l.push(links[i])
        }
        documents.folders = f
        documents.links = l

        if (items.length === 0) {
            setItems(getItems(documents))
        }

        if (loading && !isLoadingThumb) {
            return (
                <>
                    <PathLineClass documents={documents}/>
                    <LoaderClass position={'fixed'} top={120} left={'calc(50% - 24px)'}/>
                </>
            )
        }
    }

    return (
        <>
            <PathLineClass documents={documents}/>
            <LinksClass
                auth={auth}
                documents={documents}
                items={items}
                rootFolder={auth.rootFolder}
                pageToken={!!pageToken}
                setCountItems={setCountItems}
                countItems={countItems}
                navigate={navigate}
            />
        </>
    )
}
